import { useToast } from "@commonlibs";
import { UseMutationResult, useMutation, useQueryClient } from "react-query";
import useTranslate from "ui/locale/hooks/useTranslate";
import { Queries } from "ui/query/queries";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import usePointFindBy from "./usePointFindBy";
import { pointsApi } from "../api/pointsApi";

export interface UpdateConversionRateParams {
    conversionRate: number;
}

export default function useUpdateConversionRate({
    onSuccess,
    ...options
}: UseCustomMutationOptions<void, unknown, UpdateConversionRateParams> = {}): UseMutationResult<void, unknown, UpdateConversionRateParams> {
    const { showToast } = useToast();
    const translate = useTranslate();
    const queryClient = useQueryClient();
    const { data: pointData } = usePointFindBy();

    return useMutation(
        async ({ conversionRate }: UpdateConversionRateParams) => {
            const tokenAddress = pointData?.address;
            if (!tokenAddress) throw new Error("Token address not found");
            await pointsApi.updateConversionRate(tokenAddress, { conversionRate });
        },
        {
            onSuccess: (data, variables, context) => {
                showToast(translate("conversionRateUpdatedSuccessfully"), { type: "success" });
                queryClient.invalidateQueries([Queries.POINT_FIND_BY]);
                onSuccess?.(data, variables, context);
            },
            ...options,
        },
    );
}
